import html2pdf from 'html2pdf.js';

/**
 * Generate a downloadable PDF from a DOM element.
 * Returns a promise that resolves when the PDF has been saved.
 */
export async function generatePortfolioPDF(element, filename = 'Pallabi-Bose-Portfolio.pdf') {
    if (!element) throw new Error('No element provided for PDF generation');

    const opt = {
        margin: [12, 14, 14, 14],
        filename,
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#FBF8F3',
            logging: false,
            scrollY: 0,
        },
        jsPDF: {
            unit: 'mm',
            format: 'a4',
            orientation: 'portrait',
            compress: true,
        },
        pagebreak: { mode: ['css', 'legacy'], avoid: ['h2', 'h3', '.pdf-sample', '.pdf-avoid-break'] },
    };

    return html2pdf().set(opt).from(element).save();
}
